import React, { useState } from 'react'
import styled from 'styled-components'

import Popover from '../popover'
import Iconfont from './Iconfont'
import images from './images'
import { setThemeStore, getThemeStore } from './storage'

const Theme = styled.li`
  margin-left: 20px;
  font-size: 20px;
  .tnt-themeS1 & {
    /* color: rgba(255,255,255,.85); */
  }
  .isInIframe & {
    display: none;
  }
`

const ThemeSwitch = styled.div`
  & > div {
    position: relative;
    display: inline-block;
    cursor: pointer;
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 10px;
    }
    & > i,
    & > .tnt-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`

const ThemeContentWrapper = styled.div`
  z-index: 1;
  background-color: #fff;
  border-radius: 4px;
  width: 156px;
`

const themes = [
  { value: 'themeS1', img: images.themeSymbol1 },
  { value: 'themeS2', img: images.themeSymbol2 },
]

const ThemeContent = (props) => {
  const { onChange } = props
  const getTheme = () => {
    let theme = getThemeStore() || props.theme || 'themeS2'

    return themes.some(({ value }) => value === theme) ? theme : 'themeS2'
  }
  const [theme, setTheme] = useState(getTheme())
  const changeTheme = (theme) => {
    setTheme(theme)
    setThemeStore(theme)
    onChange(theme)
  }

  return (
    <ThemeContentWrapper>
      <ThemeSwitch>
        {themes.map(({ value, img }) => (
          <div key={value} onClick={changeTheme.bind(this, value)}>
            <img src={img} />
            {theme === value && <Iconfont type="check1" />}
          </div>
        ))}
      </ThemeSwitch>
    </ThemeContentWrapper>
  )
}

export default (props) => {
  return (
    <Theme>
      <Popover
        placement="bottomRight"
        title={null}
        content={<ThemeContent {...props} />}
        trigger="click"
      >
        <Iconfont type="change-theme" />
      </Popover>
    </Theme>
  )
}
